import { FlagEffect } from "./FlagEffect";
import { FlagProvider } from "@unleash/proxy-client-react";
import { Helpers } from "@merit/frontend-utils";
import { Log } from "@src/utils";
import { useConfig } from "@src/hooks";
import { useUnleashStorageProvider } from "./useUnleashStorageProvider";
import type { ProviderFunctionalComponent } from "../../types";

const { None } = Helpers;

export const Provider: ProviderFunctionalComponent = ({ children }) => {
  const storageProvider = useUnleashStorageProvider();

  const { featureFlags } = useConfig();
  if (featureFlags.provider !== "Unleash") {
    Log.error("config.featureFlags.provider is invalid", {
      provider: featureFlags.provider,
    });

    return <>{children}</>;
  }

  const { apiToken, apiUrl } = featureFlags;
  if (None(apiToken) || None(apiUrl)) {
    Log.error("config.featureFlags is missing apiToken or apiUrl", {
      provider: featureFlags.provider,
    });

    return <>{children}</>;
  }

  return (
    <FlagProvider
      config={{
        appName: "member-app",
        clientKey: apiToken,
        storageProvider,
        url: apiUrl,
      }}
    >
      <FlagEffect />
      {children}
    </FlagProvider>
  );
};
